/** @typedef {'global_search' | 'highlights_direct'} ContentHighlightsEntrySource */

export const CONTENT_HIGHLIGHTS_ENTRY_SOURCE_GLOBAL_SEARCH = 'global_search'
export const CONTENT_HIGHLIGHTS_ENTRY_SOURCE_HIGHLIGHTS_DIRECT = 'highlights_direct'

/**
 * @param {ContentHighlightsEntrySource | string | undefined | null} entrySource
 */
export function isGlobalSearchEntrySource (entrySource) {
  return entrySource === CONTENT_HIGHLIGHTS_ENTRY_SOURCE_GLOBAL_SEARCH
}
